export default "__VITE_ASSET__lBgkJZAs__"